import { SessionConfigFlags, SoundProcessorOptions, StatusCode } from '@yandex-video-platform/goloom-sdk';

import { TelemostBackendErrorCode } from './types';

export const KICKED_WHILE_RECONNECTING = 'KICKED_WHILE_RECONNECTING';

export const DEFAULT_FLAGS: SessionConfigFlags = {
    reportTelemetry: true,
};

export const SOUND_PROCESSING_OPTIONS: SoundProcessorOptions = {
    noiseCancellation: true,
};

export const DISABLED_SOUND_PROCESSING_OPTIONS: SoundProcessorOptions = {
    noiseCancellation: false,
};

export const DEFAULT_MEDIA_SERVER_URL = 'wss://goloom.strm.yandex.net/join';
export const DEFAULT_SERVICE_NAME = 'telemost';
export const DEFAULT_ICE_SERVERS = [{ urls: 'stun:stun.rtc.yandex.net:3478' }];

export const CLOSE_ERROR_CODES_TO_RETRY = [1006, 1011];

/**
 * Дополнительные коды Goloom SDK для retry (3xxx-5xxx)
 * https://docs.yandex-team.ru/goloom/integration/errors-handling#oshibki-soedineniya
 */
export const GOLOOM_CLOSE_ERROR_CODES_TO_RETRY = new Set([
    StatusCode.ACK_TIMEOUT_ERROR,
    StatusCode.AUTH_PROVIDER_IS_NOT_AVAILABLE,
    StatusCode.HELLO_SHOULD_BE_FIRST,
    StatusCode.SIGNALING_FAILED,
    StatusCode.PUBLISHER_FAILED,
    StatusCode.SUBSCRIBER_FAILED,
    StatusCode.ROOM_IS_CLOSING,
    StatusCode.NETWORK_LOST,
    StatusCode.TOO_MANY_MESSAGES,
    StatusCode.WEBSOCKET_CLOSED_WITHOUT_CODE,
]);

export const BACKEND_ERROR_CODES_TO_RETRY = [
    TelemostBackendErrorCode.CREDENTIALS_EXPIRED,
    TelemostBackendErrorCode.SESSION_NOT_FOUND,
    TelemostBackendErrorCode.INCORRECT_CREDENTIALS,
];
